
import PropTypes from 'prop-types'
import React from 'react'
import { Link as ReactRouterLink } from 'react-router'
import './Tabs.css'

const Tabs = props => (
  <ul className='Tabs2 square' data-hideBorder={props.hideBorder}>
    {props.children}
  </ul>
)

const Tab = props => {
  const { href, active, rel, target, badge, onClick } = props
  let badgeContent

  if (badge) {
    badgeContent = <span className='Tabs2-badge'>{badge}</span>
  }
  // leverage React Router's `to=` on local links
  const url = rel === 'external' ? { href: href } : { to: href }
  return (
    <li className='Tabs2-tab' data-active={!!active}>
      <ReactRouterLink className='Tabs2-link' {...url} rel={rel} target={target} onClick={onClick}>
        {
          /* XXX: the deku version only mounted the 0th child for an unknown reason. this may be something to look out for. */
          props.children
        }
        {badgeContent}
      </ReactRouterLink>
    </li>
  )
}

Tabs.displayName = 'Tabs'

Tabs.propTypes = {
  children: PropTypes.array.isRequired,
  hideBorder: PropTypes.bool
}

Tab.displayName = 'Tab'

Tab.propTypes = {
  active: PropTypes.bool.isRequired,
  badge: PropTypes.string,
  children: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  rel: PropTypes.string,
  target: PropTypes.string
}

export { Tabs, Tab }



// WEBPACK FOOTER //
// ./ui/Tabs.js